import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { IK_ACL_STATUS } from "models/acl.model";

const useFetchSourceHeaders = (source: string) => {

  const navigate = useNavigate();
  const location = useLocation();

  const id = location.pathname.substring(
    window.location.pathname.lastIndexOf("/") + 1
  );

  useEffect(() => {
    if (!source) return;

    const fetchSourceHeaders = (url: string | null = null) => {
      const urlString = url ?? source;

      const xhr = new XMLHttpRequest();
      xhr.open('GET', urlString, true);
      xhr.onreadystatechange = () => {
        const headersString = xhr.getAllResponseHeaders();

        // @ts-ignore
        const code = parseHeaders(headersString)['x-ik-acl-status'];

        switch (code) {
          case IK_ACL_STATUS.StatusCountryForbidden:
            navigate('/error', {replace: true, state: {code}});
            break;
          case IK_ACL_STATUS.StatusInvalidToken:
            navigate('/error', {replace: true, state: {code}});
            break;
          case IK_ACL_STATUS.StatusInternalError:
            navigate('/error', {replace: true, state: {code}});
        }
      };
      xhr.send();
    };

    fetchSourceHeaders();
  }, []);
};

function parseHeaders(headersString: string) {
  const headers: unknown = {};
  const lines = headersString.trim().split(/[\r\n]+/);

  lines.forEach(line => {
    const parts = line.split(': ');
    const header = parts.shift();
    const value = parts.join(': ');
    // @ts-ignore
    headers[header?.trim()] = value.trim();
  });

  return headers;
}

export default useFetchSourceHeaders
